import { Typography } from "@mui/material";
import type { JSX } from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import "./translations";

import { SprengnetterPage } from "@/components/sprengnetterPage";
import { getLogoutReturnTo } from "@/helpers/logoutNavigationHelpers";

const LogoutPage = (): JSX.Element => {
  const { t } = useTranslation("LogoutPage");
  const returnTo = useMemo(() => getLogoutReturnTo(), []);

  return (
    <SprengnetterPage>
      <Typography fontWeight="bold" variant="h3">
        {t("title")}
      </Typography>
      <Typography variant="body1">{t("subtitle")}</Typography>
      <Link to={returnTo}>{t("navigate_text")}</Link>
    </SprengnetterPage>
  );
};

(LogoutPage as any).isUnprotected = true; // eslint-disable-line @typescript-eslint/no-explicit-any

export default LogoutPage;
